import React, { useState } from 'react';
import { Modal, Form, Input } from "antd";
import { PASSWORD_PATTERN } from "../utils/regex";
import auth from './../services/authService';
import { customerId, organizationId } from '../config.json'

function ChangePasswordForm({ userId, visible, onCancel, onChanged }) {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const cancelHandler = () => {
        form.resetFields();
        onCancel();
    };

    const okHandler = async () => {
        form.validateFields().then(async values => {
            setLoading(true);
            await auth.changePassword(values);
            form.resetFields();
            setLoading(false);
            onChanged();
        }).catch(() => {});
    };

    return (<Modal visible={visible} title="Cambiar contraseña" confirmLoading={loading}
    onCancel={cancelHandler}
    onOk={okHandler}>
    <Form form={form} layout="vertical" initialValues={{ userId, customerId, organizationId }}>
        <Form.Item hidden name="customerId"><Input /></Form.Item>
        <Form.Item hidden name="organizationId"><Input /></Form.Item>
        <Form.Item hidden name="userId"><Input /></Form.Item>
        <Form.Item name="password" extra="La contraseña debe tener al menos 8 caracteres y cumplir con 3 de lo siguiente: mayúsculas, minúsculas, número y/o carácter especial (!@#$%^&*)."
            rules={[
                { required: true, message: 'Nueva contraseña no debe ser vacía' },
                { pattern: PASSWORD_PATTERN, message: 'Nueva contraseña no cumple con el criterio' }
            ]}>
            <Input.Password placeholder="Nueva contraseña" />
        </Form.Item>
    </Form>
</Modal>);
}

export default ChangePasswordForm;


// WEBPACK FOOTER //
// ./src/components/ChangePasswordForm.jsx